import React from 'react';

import useOnScreen from '../../helpers/useOnScreen';
import { TrackingContext } from '../../TrackingContext';
import GuidanceCard from '../BaseGuidanceCard';
import { ShopByPriceModule } from '../PreviewPage/ShopByPriceModule';

export const addGiftsAndCashFundsV2 = '/registry';

interface RegistryGuidanceCardProps {
  onRegistryItemAdded?: () => void;
}

const RegistryGuidanceCard: React.FC<RegistryGuidanceCardProps> = ({ onRegistryItemAdded }) => {
  const { track } = React.useContext(TrackingContext);

  const routeToRegistryV2 = () => {
    track('WWS Dashboard Interaction', {
      action: 'add',
      actionName: 'giftsandcashfunds',
    });

    window.open(addGiftsAndCashFundsV2, '_blank');
  };

  const { ref } = useOnScreen({
    onFirstSeen: () => {
      track('WWS Registry CTA Impression', {
        type: 'page card',
      });
    },
  });

  return (
    <div ref={ref} data-testid="registry-guidance-card">
      <GuidanceCard
        type="registry"
        titleText="All-in-one registry"
        primaryLinkText="Add gifts & cash funds"
        primaryOnClick={routeToRegistryV2}
        bulletPoints={[
          'Add gifts from The Knot Registry Store (and get 20% off post-wedding).',
          'Sync gifts from your other registries.',
          'Track all your gifts in one place!',
        ]}
      >
        <ShopByPriceModule isPreview={false} onItemAdded={onRegistryItemAdded} />
      </GuidanceCard>
    </div>
  );
};

export default RegistryGuidanceCard;
